import type { PartTone } from './types.ts';

export interface PartToneClasses {
    tile: string;
    icon: string;
    check: string;
}

// Full literal class names so Tailwind's scanner keeps every tone in the build.
export const PART_TONE_CLASSES: Record<PartTone, PartToneClasses> = {
    blue: { tile: 'bg-blue-100', icon: 'text-blue-600', check: 'text-blue-500' },
    green: { tile: 'bg-green-100', icon: 'text-green-600', check: 'text-green-500' },
    amber: { tile: 'bg-amber-100', icon: 'text-amber-600', check: 'text-amber-500' },
    indigo: { tile: 'bg-indigo-100', icon: 'text-indigo-600', check: 'text-indigo-500' },
    rose: { tile: 'bg-rose-100', icon: 'text-rose-600', check: 'text-rose-500' },
    teal: { tile: 'bg-teal-100', icon: 'text-teal-600', check: 'text-teal-500' },
    purple: { tile: 'bg-purple-100', icon: 'text-purple-600', check: 'text-purple-500' }
};
